__turbopack_context__.v({
  "badge": "JSKdkW_badge",
  "fieldWrap": "JSKdkW_fieldWrap",
  "suggestionItem": "JSKdkW_suggestionItem",
  "suggestionItemCustom": "JSKdkW_suggestionItemCustom",
  "suggestions": "JSKdkW_suggestions",
});
